import styled from "styled-components/macro"

const orange = props => props.theme.colors.orange
export default styled.label`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  input::after {
    content: "";
    position: absolute;
    display: none;
  }

  input:checked ~ label {
    color: ${orange};
  }

  input:checked ~ span {
    border-color: ${orange};
  }

  input:checked ~ span::after {
    display: block;
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: ${orange};
  }
  
  &:hover {
    color: ${orange};
    input ~ span {
      border-color: ${orange};
    }
  }
`

export const RadioCircle = styled.span`
  position: relative;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 2px solid ${props => props.theme.colors.radioInactive};
  border-radius: 50%;
  margin: 0 0.5em;
`

export const RadioWrapper = styled.div`
  display: flex;
  flex: 3;
  justify-content: space-around;
  align-self: flex-end;
  &::after {
    content: "";
  }
`